export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";